import { render, staticRenderFns } from "./AutoprovisioningDashboard.vue?vue&type=template&id=35798036&scoped=true"
import script from "./AutoprovisioningDashboard.vue?vue&type=script&lang=js"
export * from "./AutoprovisioningDashboard.vue?vue&type=script&lang=js"
import style0 from "./AutoprovisioningDashboard.vue?vue&type=style&index=0&id=35798036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35798036",
  null
  
)

export default component.exports